import { configureStore } from "@reduxjs/toolkit"

import loggerMiddleware from "./middlewares/logger"
import sagaMiddleware, { initSagaMiddleware } from "./middlewares/saga"
import rootReducer from "./root-reducer"

const store = getStore()

export default function initStore() {
  initSagaMiddleware()

  return store
}

/*
 * Utils
 */

// For unit tests
function getStore() {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(sagaMiddleware, loggerMiddleware), // logger last
  })
}

export type IAppDispatch = typeof store.dispatch
export type IStore = typeof store
